<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="manualDippingService.loading$"
	confirmButtonText="gl.create"
	size="md"
	[disabled]="mdTaskForm.invalid">
	<h6 slot="header">{{ 'manual_dipping.add_title' | translate }}</h6>
	<div slot="content">
		<form [formGroup]="mdTaskForm">
			@if(dnisFilesService.uploadError | async) {
			<alaris-alert [type]="'warning'" [bg]="'primary'" style="margin: 1rem 0">
				<ng-container>{{ 'manual_dipping.upload_error' | translate }}</ng-container>
			</alaris-alert>
			}
			<alaris-multi-select2
				[label]="'manual_dipping.source' | translate"
				[alarisLoading]="sources.loading$"
				[optionsCount]="(filteredSources$ | async)?.length || 0"
				[showAllSelected]="true"
				formControlName="Sources"
				mode="tag"
				[errors]="errors">
				<alaris-select-filter2 [formControl]="sourcesFilter"></alaris-select-filter2>
				@for (source of filteredSources$ | async; track source) {
				<alaris-multi-options2 [value]="source.Name">
					<span>{{ source.Name }}</span>
				</alaris-multi-options2>
				}
			</alaris-multi-select2>
			<alaris-checkbox [size]="'xl'" formControlName="NoCache" style="margin: 1rem 0">
				{{ 'manual_dipping.ignore_cache' | translate }}
			</alaris-checkbox>
			<div>
				<p>{{ 'manual_dipping.dnis' | translate }}</p>
				<alaris-tabs class="tabs" [underline]="true">
					<alaris-tab [label]="'manual_dipping.manually' | translate" tabId="manually">
						<alaris-text-area [errors]="errors" wrap="off" formControlName="Numbers" class="tab-content">
							{{ 'manual_dipping.enter_values' | translate }}
						</alaris-text-area>
					</alaris-tab>

					<alaris-tab [label]="'manual_dipping.document' | translate" tabId="document">
						<alaris-file-loader
							[fileTypes]="'.csv, .xlsx, .xls'"
							[maxSize]="10485760"
							[multiple]="false"
							[files]="files"
							[exportInternally]="true"
							[id]="'loaderId'"
							class="tab-content"></alaris-file-loader>
					</alaris-tab>
				</alaris-tabs>
			</div>
		</form>
	</div>
</alaris-dialog>
